// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3NiK9","right":"Footer_right__15JgE","buttons":"Footer_buttons__3y0NO"};